export const ORIGIN_LOCAL     = 'local';
export const ORIGIN_HYDRATION = 'hydration';

export function withLocalTransaction(doc, fn) {
    return doc.transact(fn, ORIGIN_LOCAL);
}

export function withHydrationTransaction(doc, fn) {
    return doc.transact(fn, ORIGIN_HYDRATION);
}
